import client from './client';

export const getImageList = (appId, data) => {
	return client({
		url: '/image',
		method: 'get',
		params: data,
		headers: {
			ApplicationID: appId,
		},
	});
};

export const downloadImage = (data, appId) => {
	return client({
		url: '/image/view',
		method: 'get',
		params: data,
		headers: {
			ApplicationID: appId,
		},
		responseType: 'blob',
	});
};

export const downloadImageAll = (fileName) => {
	return client({
		url: `/files/download/${fileName}`,
		method: 'get',
		responseType: 'blob',
	});
};

export const uploadImageAndSubmit = (data, onUploadProgress, appId) => {
	return client({
		url: '/image',
		method: 'post',
		data,
		headers: {
			'Content-Type': 'multipart/form-data',
			ApplicationID: appId,
		},
		onUploadProgress: onUploadProgress || function () {},
	});
};

export const deleteImage = (data, appId) => {
	return client({
		url: `/image`,
		method: 'delete',
		data,
		headers: {
			ApplicationID: appId,
		},
	});
};

export const approveImage = (data, appId) => {
	return client({
		url: `/image/approve`,
		method: 'patch',
		data,
		headers: {
			ApplicationID: appId,
		},
	});
};

export const updateImage = (id, data, appId) => {
	return client({
		url: `/image/${id}`,
		method: 'patch',
		data,
	});
};
